
export interface FilterForm{
  style_code?: string;
  colour?: string;
  supplier_name?: string;
  client_pos?: string;
}

export const Filters={
  STYLE_CODE:'style_code',
  COLOR:'colour',
  SUPPLIER_NAME:'supplier_name',
  CLIENT_PO:'client_pos',
  EXIST_INSP_REPORT:'exists_inspection_report'
}
